import { useEffect } from "react";

import { useChatPanelStore } from "../store/chatPanelStore";
import { useRightPanelStore } from "../store/rightPanelStore";

/**
 * Mobile (<lg, 1024px): chat panel is collapsed exactly while the right
 * panel is open. Single effect — no racing coordination. Opening the task
 * panel hides the chat; closing it restores the chat. Mounted once in the
 * chat route.
 */
export function useMobilePanelCoordination(): void {
  const rightOpen = useRightPanelStore((s) => s.isOpen);
  const setChatCollapsed = useChatPanelStore((s) => s.setCollapsed);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1023px)");
    if (!mq.matches) return;
    setChatCollapsed(rightOpen);
  }, [rightOpen, setChatCollapsed]);
}
